import * as R from "ramda";
import { IAwsMediaEdits } from './Image';

/**
 * Check if a url belongs to Cinio's AWS bucket
 * @param url
 */
export const canUseMediaHandler = (url: string) => {
    return !!url.match(`/${AWS_BUCKET_NAME}/`);
};

/**
 * Base64-encode a UTF-8 string, safely handling the full Unicode range.
 * @param value
 */
const utf8ToBase64 = (value: string): string => {
    const utf8Bytes = new TextEncoder().encode(value);
    let binary = "";
    utf8Bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });
    return btoa(binary);
};

/**
 * Get media url pointing to AWS ServerlessMediaHandler
 * @param src
 * @param edits
 */
export const getMediaHandlerUrl = (src: string, edits: IAwsMediaEdits) => {
    const hasEdits = edits.height || edits.width || edits.fit;

    if (!hasEdits) {
        return src;
    }

    try {
        const options =  {
            bucket : AWS_BUCKET_NAME,
            key    : getKeyFromUrl(src),
            edits  : { resize: R.pick(["width", "height", "resize"], edits) }
        };

        return AWS_MEDIA_HANDLER_API + "/" + utf8ToBase64(JSON.stringify((options)));
    } catch (error) {
        return src;
    }
};

/**
 * Get AWS bucket key from url
 * @param url
 */
const getKeyFromUrl = (url: string): string => {
    const splitUrl = url.split(`/${AWS_BUCKET_NAME}/`);
    const key = R.last(splitUrl) as string;
    return key;
};
